import { tint } from 'polished';

import {
  BrandColors,
  CustomColors,
  DefaultColors,
  GreyColors,
  SemanticColors,
} from './theme.types';

import { darks, lights } from './tints';

export const customColors: CustomColors = {
  primary: '#85A2AA',
  background: '#ffffff',
  secondary: '#455B61',
  tertiary: '#B5D3DC',
  navigationAndFooter: '#333333',
  header: '#F4F4F4',
  sectionTitle: '#919191',
  borderGrey: '#E0E0E0',
  borderGreyLighter: '#EFEFEF',
  primaryLight: lights('#0d3c47'),
  primaryDark: darks('#0d3c47'),
  secondaryLight: lights('#e3cfc9'),
  secondaryDark: darks('#e3cfc9'),
  tertiaryLight: lights('#f5f3ec'),
  tertiaryDark: darks('#f5f3ec'),
};

export const defaultColors: DefaultColors = {
  fontPrimary: '#444444',
  fontSecondary: '#666666',
  darkGrey: '#646464',
  grey: '#C1C1C1',
  lightGrey: '#E2E2E2',
  lighterGrey: '#F7F7F7',
  requiredRed: '#E55646',
  info: '#01579B',
  infoBackground: '#E6EEF5',
  sale: '#E2363F',
  overlay: 'rgba(161,161,174,0.02)',
  error: '#E55646',
  errorBackground: '#FDEEEB',
  success: '#009688',
  successBackground: '#E5F4F3',
  black: '#000000',
  white: '#FFFFFF',
  offWhite: '#f1f1f1',
  offGrey: '#eff0f1',
};

export const brandColors: BrandColors = {
  primary: '#85A2AA',
  secondary: '#455B61',
  tertiary: '#B5D3DC',
  navigationAndFooter: '#333333',
  header: '#F4F4F4',
  sectionTitle: '#919191',
};

export const semanticColors: SemanticColors = {
  blueDark: '#0d66d0',
  blueLight: '#dce9fa',
  redDark: '#c9252d',
  redLight: '#f9e0e1',
  orangeDark: '#cb6f10',
  orangeLight: '#f8ebdc',
  greenDark: '#12805c',
  greenLight: '#ddede8',
};

const greyColor = '#121212';

export const greyColors: GreyColors = {
  'grey-100': greyColor,
  'grey-90': tint(0.08, greyColor),
  'grey-80': tint(0.16, greyColor),
  'grey-70': tint(0.28, greyColor),
  'grey-60': tint(0.4, greyColor),
  'grey-50': tint(0.52, greyColor),
  'grey-40': tint(0.64, greyColor),
  'grey-30': tint(0.76, greyColor),
  'grey-20': tint(0.84, greyColor),
  'grey-10': tint(0.92, greyColor),
  'grey-5': tint(0.96, greyColor),
};
